import { errorHandler } from '@/composables/errorHandler'
import { t } from '@/i18n'
import { notificationService } from '@/services/notificationService'
import { useCommonStore, useOperatorReportingV2Store, useReportExecutionV2Store } from '@/stores'
import { reportExecutionService } from '@/views/ReportsV2/services/reportExecutionService'

export function createOperatorReportingCreatePrefetchGuard() {
    return async (to: { name?: string | symbol | null }) => {
        const commonStore = useCommonStore()
        const operatorReportingStore = useOperatorReportingV2Store()
        const reportExecutionStore = useReportExecutionV2Store()
        const createReportContext = reportExecutionStore.operatorReportingCreateContext
        const workspace = operatorReportingStore.selectedWorkspace

        reportExecutionStore.setPrefetchedCreateTask(null)

        if (!createReportContext?.taskId || !createReportContext.processId || !workspace) {
            notificationService.error(t('reports.reportExecution.create.notifications.missingContext'))
            return { name: 'reportsV2OperatorReportingHome' }
        }

        commonStore.toggleMainLoader(true)

        try {
            const response = await reportExecutionService.fetchTaskDetails(createReportContext, workspace.id)
            const task = response.data
            const plate =
                to.name === 'reportsV2OperatorReportingCreatePrint'
                    ? reportExecutionService.findPrintEntryPlate(task, createReportContext.plateNumber)
                    : reportExecutionService.findPlate(task, createReportContext.plateNumber)

            if (!plate) {
                notificationService.info(t('reports.reportExecution.create.notifications.taskFullyReported'))
                return { name: 'reportsV2OperatorReportingHome' }
            }

            reportExecutionStore.setPrefetchedCreateTask(task)

            return true
        } catch (error) {
            errorHandler(error)
            commonStore.toggleMainLoader(false)
            return false
        }
    }
}
